import { Component, Input, OnChanges, OnDestroy, OnInit, SimpleChanges } from '@angular/core';
import { Subject } from 'rxjs';
import { takeUntil } from 'rxjs/operators';

import { EditorDataService } from '../editor-data/editor-data.service';


@Component({
    selector: 'eas-editor-booking-item-bundle-summary',
    templateUrl: './editor-booking-item-bundle-summary.component.html',
    styleUrls: ['./editor-booking-item-bundle-summary.component.css'],
    standalone: false
})
export class EditorBookingItemBundleSummaryComponent implements OnChanges, OnInit, OnDestroy {
  @Input() bundle: string[];

  private destroyed$ = new Subject<void>();

  bookingItemNames: { id: string, name: string }[];

  summary: string;

  constructor(
    private editorData: EditorDataService
  ) {

  }

  ngOnInit() {
    this.editorData.bookingItemNames$
      .pipe(
        takeUntil(this.destroyed$)
      )
      .subscribe(bookingItemNames => {
        this.bookingItemNames = bookingItemNames;
        this.updateSummary();
      });
  }

  ngOnChanges(changes: SimpleChanges) {
    if (changes.item) {
      if (this.bookingItemNames !== undefined) {
        this.updateSummary();
      }
    }
  }

  ngOnDestroy() {
    this.destroyed$.next();
    this.destroyed$.complete();
  }

  updateSummary() {
    this.summary = this.bundle
      .map(
        bundleItemId =>
          this.bookingItemNames.find(bookingItemName => bookingItemName.id === bundleItemId).name
      )
      .join(', ');
  }
}
